"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = exports.CognitoRole = void 0;
var dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
var base_service_1 = require("./base.service");
var serializers_1 = require("./serializers");
var api_constants_1 = require("../constants/api.constants");
var roles_serializer_1 = require("./serializers/roles.serializer");
var dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
var dp_acma_dawn_sdk_2 = require("@greatmindsorg/dp-acma-dawn-sdk");
Object.defineProperty(exports, "CognitoRole", { enumerable: true, get: function () { return dp_acma_dawn_sdk_2.CognitoRole; } });
var AuthService = /** @class */ (function (_super) {
    __extends(AuthService, _super);
    function AuthService(options, client, authClient, roleClient, logoutSerializer, roleSerializer) {
        var _this = _super.call(this, options) || this;
        _this.client = client;
        _this.authClient = authClient;
        _this.roleClient = roleClient;
        _this.logoutSerializer = logoutSerializer;
        _this.roleSerializer = roleSerializer;
        return _this;
    }
    AuthService.newInstance = function (options) {
        return new AuthService(options, dp_http_client_lib_1.RetryableHttpClient.newInstance({
            baseURL: api_constants_1.AUTH_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), dp_acma_dawn_sdk_1.AuthClient.newInstance({
            baseURL: api_constants_1.AUTH_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), dp_acma_dawn_sdk_1.RoleClient.newInstance({
            baseURL: api_constants_1.AUTH_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.LogoutSerializer(), new roles_serializer_1.RoleSerializer());
    };
    AuthService.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authClient.logout()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.logoutSerializer.serialize(data)];
                }
            });
        });
    };
    AuthService.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authClient.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.getRoles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.roleClient.findRoles()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.roleSerializer.serialize(data)];
                }
            });
        });
    };
    AuthService.prototype.updateActiveRole = function (role) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.roleClient.switchRole(role)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.getImpersonatorProfile = function () {
        return this.client.get('/auth/impersonate/profile', this.getRosterDefaultHeaders());
    };
    AuthService.prototype.endImpersonation = function () {
        return this.client.post('/auth/impersonate/v2/end', this.getRosterDefaultHeaders());
    };
    AuthService.prototype.retryOptionsOnNonAuthorized = function () {
        var _this = this;
        return {
            when: function (error) { return __awaiter(_this, void 0, void 0, function () {
                var response, retry;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            response = error.response;
                            retry = response && response.status === 401;
                            if (!retry) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.refresh()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/, retry];
                    }
                });
            }); },
            times: 1,
        };
    };
    return AuthService;
}(base_service_1.BaseService));
exports.AuthService = AuthService;
